import script from "./EventSearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSearchBar.vue?vue&type=script&setup=true&lang=js"

import "./EventSearchBar.vue?vue&type=style&index=0&id=2a61caf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a61caf2"]])

export default __exports__